<santander-invoice-no-shared-finish
  [errorMessage]="errorMessage"
  [embeddedMode]="embeddedMode"
  [merchantMode]="merchantMode"
  [showCloseButton]="showCloseButton"
  [isDisableChangePayment]="isDisableChangePayment"
  [nodeResult]="paymentResponse"
  [isLoading]="!paymentResponse && !errorMessage"
  (cleanUp)="cleanUp()"
  (close)="close()"
  (tryAgain)="tryAgain()"
  (closeButtonClicked)="close()"
  (changePaymentMethod)="changePayment($event)"
></santander-invoice-no-shared-finish>
